class AutomationCreationActionTypes {}
AutomationCreationActionTypes.OPEN_AUTOMATION_CREATION_POPUP = "OPEN_AUTOMATION_CREATION_POPUP"
AutomationCreationActionTypes.CLOSE_AUTOMATION_CREATION_POPUP = "CLOSE_AUTOMATION_CREATION_POPUP"
AutomationCreationActionTypes.CREATE_AUTOMATION_RESPONSE = "CREATE_AUTOMATION_RESPONSE"
AutomationCreationActionTypes.EDIT_AUTOMATION_RESPONSE = "EDIT_AUTOMATION_RESPONSE"

export default AutomationCreationActionTypes
